import { Layout } from 'antd'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import ModalShadow from './ModalShadow'
import DetailView from './DetailView'
import TableView from './TableView'
import CreateNodeView from './CreateNodeView'
import EditNodeView from './EditNodeView'
import './index.scss'
{ Content } = Layout

class Overlay extends React.Component

  constructor: (props) ->
    super(props)

  render: ->
    { left, nodeId, tableConf, isCreatingNode, isEditingNode, style, width, height, match: { path } } = @props

    <Layout className="overlay-container" style={{ width: width - left }}>
      <ModalShadow left={left} />
      <ReactCSSTransitionGroup
        transitionName="modal"
        transitionEnterTimeout={250}
        transitionAppearTimeout={250}
        transitionLeaveTimeout={250}
        transitionAppear={true}
        style={{ height: '100%', display: 'flex' }}
      >
        <Layout
          data-testid="graph-overlay"
          className="modal-container"
          style={{
            style...,
            width: width - left
          }}
        >
          {
            if nodeId
              <DetailView nodeId={nodeId} key={nodeId} left={left} />
            else if tableConf
              <TableView conf={tableConf} left={left} height={height} />
            else if isCreatingNode
              <CreateNodeView />
            else if isEditingNode
              <EditNodeView />
          }
        </Layout>
      </ReactCSSTransitionGroup>
    </Layout>

mapStateToProps = ({ explore }) ->
  {
    width: explore.width
    height: explore.height
  }

export default withRouter(connect(mapStateToProps)(Overlay))
